import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { IElementTemplate } from 'elements/types';
import { Color } from 'theme/enums';

import { UpsertElementTemplate } from './UpsertElementTemplate';

interface IProps {
  elementTemplate?: IElementTemplate;
  buttonElement?: ReactElement;
  disabled?: boolean;
}

export const UpsertElementTemplateButton = ({
  elementTemplate,
  buttonElement,
  disabled = false,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { updateRows } = useAgGridClientTableContext();

  const onSubmitSuccess = (updatedElementTemplate: IElementTemplate) => {
    const isEdit = !!elementTemplate?.id;

    if (isEdit) {
      updateRows({ update: [updatedElementTemplate] });
    } else {
      updateRows({ add: [updatedElementTemplate] });
    }
  };

  const button = buttonElement ? (
    cloneElement(buttonElement, {
      onClick: disabled ? undefined : () => setIsOpen(true),
    })
  ) : (
    <Button
      text={t('buttonLabelAddElementTemplate')}
      color={Color.SUCCESS}
      startDecorator={<Plus />}
      onClick={() => setIsOpen(true)}
      disabled={disabled}
    />
  );

  return (
    <>
      {button}

      <UpsertElementTemplate
        elementTemplate={elementTemplate}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
